<div class="container disabled-container">
  <div class="disabled-box">
    <img src="assets/yachtapp-logo-dark.png" alt="YachtApp Logo" class="logo">
    <img src="assets/images/sailboat.svg" alt="YachtApp disabled" class="sailboat">
    <h1>App Disabled</h1>
    <p>YachtApp is temporarily unavailable. Please check back soon.</p>
  </div>
</div>
